import { PARTICIPANT_TYPE_ID } from '../constants/participantTypes';
import { GuarantorItem } from '../types/operations';

interface ParticipantData {
    id?: number | null;
    uuid?: string;
    document?: string;
}

interface GenerateParticipantsParams {
    assignorName: string;
    assignorParticipant: ParticipantData;
    recipientName: string;
    recipientParticipant: ParticipantData;
    recipientDocument: string;
    selectedBeneficiary: string;
    guarantors: GuarantorItem[];
    conditionalPersonId?: boolean;
}

const EMPTY_UUID = '00000000-0000-0000-0000-000000000000';

const isValidPersonId = (id?: string) => id && id !== EMPTY_UUID;

export const generateParticipants = ({
    assignorName,
    assignorParticipant,
    recipientName,
    recipientParticipant,
    recipientDocument,
    selectedBeneficiary,
    guarantors,
    conditionalPersonId = false,
}: GenerateParticipantsParams) => {
    const assignorPersonId = assignorParticipant.uuid || EMPTY_UUID;
    const recipientPersonId = selectedBeneficiary || EMPTY_UUID;

    return [
        {
            id: assignorParticipant.id,
            name: assignorName,
            document: assignorParticipant.document || "",
            is_active: true,
            ...(conditionalPersonId
                ? (isValidPersonId(assignorPersonId) && { person_id: assignorPersonId })
                : { person_id: assignorPersonId }),
            is_primary: true,
            effective_to: null,
            effective_from: new Date().toISOString(),
            guarantee_value: null,
            participant_type_id: PARTICIPANT_TYPE_ID.ASSIGNOR,
            participation_order: 1,
            guarantee_percentage: null,
            participant_type_name: "ASSIGNOR",
            receives_disbursement: false
        },
        {
            id: recipientParticipant.id,
            name: recipientName,
            document: recipientDocument,
            is_active: true,
            ...(conditionalPersonId
                ? (isValidPersonId(recipientPersonId) && { person_id: recipientPersonId })
                : { person_id: recipientPersonId }),
            is_primary: false,
            effective_to: null,
            effective_from: new Date().toISOString(),
            guarantee_value: null,
            participant_type_id: PARTICIPANT_TYPE_ID.RECIPIENT,
            participation_order: 2,
            guarantee_percentage: null,
            participant_type_name: "RECIPIENT",
            receives_disbursement: false
        },
        ...guarantors.map((guarantor, index) => ({
            id: guarantor.id ? Number(guarantor.id) : null,
            name: guarantor.name,
            document: guarantor.document,
            is_active: true,
            person_id: guarantor.uuid,
            is_primary: false,
            effective_to: null,
            effective_from: new Date().toISOString(),
            guarantee_value: null,
            participant_type_id: PARTICIPANT_TYPE_ID.GUARANTOR,
            participation_order: 3 + index,
            guarantee_percentage: null,
            participant_type_name: "GUARANTOR",
            receives_disbursement: false
        }))
    ];
};
